import styled, { css } from 'styled-components';

export const LeasedFilterContainer = styled.div`
  label {
    ${({ $isPashaLanding, theme }) => {
      return !$isPashaLanding
        ? `border: 1px solid ${theme.colors.border.primary};`
        : '';
    }}

    &::after {
      display: none;
    }

    @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
      padding: 0 10px;
      height: 45px;
      border: none;
    }
  }

  label:nth-child(1) {
    margin-bottom: 15px;

    @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
      margin: 0;
    }
  }
`;

export const popoverStyles = css`
  padding: 15px 5px;
`;
